// generated from 217 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastNameFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_name_filter"),
  comparison_key: z.enum([
    "1", // 172 (79.26%)
    "11", // 23 (10.60%)
    "2", // 12 (5.53%)
    "10", // 5 (2.30%)
    "12", // 3 (1.38%)
    "17", // 2 (0.92%)
  ]),
  display_name: z.string(),
  // undefined: 63 (29.03%), defined 154 (70.97%)
  // null for a blank comparison (11/12) once allow_nil_blank_filters is on: stored as nil
  // (Filter.enforce_nil_for_blank_comparison) and echoed as raw_value via Filter#get_raw_value
  raw_value: z.string().nullable().optional(),
  value: z.string().nullable(),
  varies_by_app_group: z.literal(false),
});
